import type { ExportJob } from '@atlas/shared';
import { listExports } from './callables.js';
import { poll, type Unsubscribe } from './poll.js';

/**
 * Poll every export across all users, newest first. The listExports callable
 * is admin-only, as the exports collection was; mutations happen only via
 * callables.
 */
export function subscribeToAllExports(
  onUpdate: (exports: Array<ExportJob & { id: string }>) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  return poll(async () => (await listExports()).data.exports, onUpdate, onError);
}
